import React from 'react';
import classNames from 'classnames';
import { Typography } from '@royalaholddelhaize/design-system-pantry-web/foundation/typography/typography';
import { TypographyProps } from '@royalaholddelhaize/design-system-pantry-web/foundation/typography/typography.interfaces';
import css from './attention-message-text.module.scss';

export const AttentionMessageText: React.FC<
    TypographyProps & React.ComponentProps<'p'>
> = ({ className, ...restProps }) => (
    <Typography
        variant="body-regular"
        className={classNames(css.root, className)}
        {...restProps}
    />
);
